"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemUpdateTransport = exports.LineItemCreateTransport = exports.InvoiceLineItemCreateTransport = exports.LineItemTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const invoice_reference_transport_1 = require("./invoice-reference-transport");
/**
 * Unified billing (v2) line item.
 */
exports.LineItemTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    invoiceID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    itemName: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Integer(),
    taxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxable: typebox_1.Type.Boolean(),
    orderItemID: typebox_1.Type.Optional(typebox_1.Type.String()),
    references: typebox_1.Type.Array(invoice_reference_transport_1.LineItemReferenceTransport),
    metadata: typebox_1.Type.Optional(common_1.MetaData),
});
/**
 * Line item as written inside an invoice create, where the invoice and hauler come from the parent.
 * `totalPrice` is optional: omit it and the server computes `round(quantity * unitPrice)`; pass it to
 * override (fees, percent-based lines, rounding).
 */
exports.InvoiceLineItemCreateTransport = typebox_1.Type.Object({
    itemName: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    quantity: typebox_1.Type.Number(),
    unitPrice: typebox_1.Type.Number(),
    totalPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    taxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    taxable: typebox_1.Type.Boolean(),
    orderItemID: typebox_1.Type.Optional(typebox_1.Type.String()),
    references: typebox_1.Type.Optional(typebox_1.Type.Array(invoice_reference_transport_1.InvoiceReferenceTransport)),
});
/** Line item as written on its own, against an existing invoice. */
exports.LineItemCreateTransport = typebox_1.Type.Composite([
    exports.InvoiceLineItemCreateTransport,
    typebox_1.Type.Object({
        invoiceID: typebox_1.Type.String({ format: 'uuid' }),
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
/** Omitting `totalPrice` while sending `quantity` or `unitPrice` recomputes it. */
exports.LineItemUpdateTransport = typebox_1.Type.Partial(exports.InvoiceLineItemCreateTransport);
//# sourceMappingURL=line-item-transport.js.map